import { formatCopy } from "../../theme/copy";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useThemeContext } from "../../globalContext/global-context";

export const CountdownRing = ({
  availableAtMs,
  durationSeconds,
}: {
  availableAtMs: number;
  durationSeconds: number;
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const interval = setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= availableAtMs) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, [availableAtMs]);

  const remainingMs = Math.max(0, availableAtMs - now);
  if (remainingMs === 0) return null;
  const remainingSeconds = Math.ceil(remainingMs / 1000);
  const progress = Math.min(
    100,
    (remainingMs / (durationSeconds * 1000)) * 100,
  );

  return (
    <Box
      data-testid="question-countdown"
      role="timer"
      aria-label={formatCopy(theme.copy.status.secondsRemaining, {
        seconds: remainingSeconds,
      })}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        width: 64,
        height: 64,
      }}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={64}
        thickness={4}
        sx={{ position: "absolute", color: theme.tokens.color.surface.card }}
      />
      <CircularProgress
        variant="determinate"
        value={progress}
        size={64}
        thickness={4}
        sx={{ position: "absolute", color: theme.tokens.color.action.primary }}
      />
      <Typography
        sx={{
          color: theme.tokens.color.text.inverse,
          fontSize: theme.tokens.typography.size.lg,
        }}
      >
        {formatCopy(theme.copy.status.countdown, { seconds: remainingSeconds })}
      </Typography>
    </Box>
  );
};
